/** AUTO-GENERATED - DO NOT CHANGE MANUALLY **/

export const IconList = [
  'ActiveMonitoring',
  'AcupunctureBack',
  'AlarmClock',
  'AlertSignFill',
  'AlertSignStroke',
  'Amputation',
  'Anxiety',
  'Apple',
  'Archive',
  'ArmFlexing',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowUpRight',
  'Attachment',
  'Atv',
  'Avatar',
  'AwakePersonOnPillow',
  'Baby',
  'BandAid',
  'BeerAndPills',
  'Bell',
  'Bike',
  'BirthControl',
  'BirthdayCake',
  'Boat',
  'Body',
  'Braille',
  'Brain',
  'BreastReconstruction',
  'BreastRemoval',
  'Breasts',
  'BrokenHeart',
  'BrokenPuzzle',
  'Bus',
  'Calendar',
  'CalendarChange',
  'CalendarCheck',
  'CalendarEvent',
  'CalendarSave',
  'Cancer',
  'Candle',
  'Car',
  'Carton',
  'Change',
  'Check',
  'CheckFill',
  'CheckOutline',
  'Chest',
  'ChevronDown',
  'ChevronLeft',
  'ChevronRight',
  'ChevronsDown',
  'ChevronsUp',
  'ChevronUp',
  'ChildPlaying',
  'Cigarette',
  'Coins',
  'Contacts',
  'Copy',
  'CoronaCertificate',
  'Coronavirus',
  'Cough',
  'CreditCard',
  'CriticalHealthInfo',
  'Cross',
  'DataExchange',
  'DataReceived',
  'DataSent',
  'Depression',
  'DigestiveSystem',
  'Dizzy',
  'Documents',
  'Dog',
  'DonorCard',
  'DotAttachment',
  'DotCheckmark',
  'DotCircleArrows',
  'DotDot',
  'DotExclamationMark',
  'DotFill',
  'DotGroup',
  'DotHalfDisc',
  'DotInfo',
  'DotLogin',
  'DotLookingGlass',
  'DotNoAccess',
  'DotNoEye',
  'DotOutline',
  'DotPencil',
  'DotQuestionMark',
  'DotTriangle',
  'DotX',
  'Download',
  'Draft',
  'Drag',
  'Ear',
  'EarDeaf',
  'EarHearingAid',
  'EarNoseThroat',
  'EarVolume',
  'EChat',
  'Edit',
  'ElderlyPerson',
  'Embolization',
  'EmergencyCall',
  'EmoticonAnnoyed',
  'EmoticonDelighted',
  'EmoticonDisappointed',
  'EmoticonHappy',
  'EmoticonMeh',
  'EmptyBox',
  'EnterFullScreen',
  'Envelope',
  'Epilepsy',
  'Eraser',
  'ErrorSignFill',
  'ErrorSignStroke',
  'EuropeanHealthCard',
  'ExitFullScreen',
  'Eye',
  'Facebook',
  'FallingLeaf',
  'Feedback',
  'Female',
  'FemaleDoctor',
  'Ferry',
  'File',
  'Filter',
  'FingerBleed',
  'FirstAidKit',
  'Fish',
  'FloppyDisk',
  'Football',
  'Form',
  'Forward',
  'Gallery',
  'Garden',
  'GasCan',
  'GenderIdentity',
  'Glasses',
  'GlassWater',
  'Globe',
  'Grain',
  'Graph',
  'Group',
  'GroupTwins',
  'HandsAndHeart',
  'HandWaving',
  'HandWithDisease',
  'HealthcarePerson',
  'HealthcarePersonell',
  'HealthClinic',
  'HealthMeasurements',
  'HealthWarning',
  'HearingProtection',
  'Heart',
  'HeartHands',
  'HelpingHand',
  'HelpSign',
  'Hemodialysis',
  'Hiker',
  'Hipprosthesis',
  'History',
  'HivAndAids',
  'Home',
  'HomeFill',
  'Hormone',
  'Hospital',
  'Hourglass',
  'HTMLFile',
  'ImgFile',
  'Inbox',
  'InfoSignFill',
  'InfoSignStroke',
  'Instagram',
  'Intravenous',
  'JointPain',
  'Journal',
  'JpgFile',
  'Kidney',
  'KitchenScale',
  'Kjernejournal',
  'Laboratory',
  'LaptopBlog',
  'LawBook',
  'LegalDocument',
  'LightBulb',
  'List',
  'Location',
  'LocationFill',
  'Lock',
  'Login',
  'Logout',
  'Lungs',
  'Makeup',
  'MaleDoctor',
  'MaleDoctorAndPerson',
  'MaleDoctorCompact',
  'MaleDoctorCompactFill',
  'MaleGenitalia',
  'MeasuringTape',
  'Medicine',
  'MedicineWarning',
  'MentalHealthAdult',
  'MentalHealthChild',
  'Menu',
  'Microscope',
  'Minus',
  'Mirror',
  'MobilePhone',
  'MotherHoldingBaby',
  'MuscleBack',
  'MuscleLeg',
  'Mushroom',
  'Music',
  'MusselsAndSalt',
  'NoAccess',
  'NoEye',
  'NoFilter',
  'Notepad',
  'Osteotomy',
  'PaintRoller',
  'PaperPlane',
  'PatientAndPerson',
  'Pause',
  'PdfFile',
  'Pencil',
  'PeopleTalking',
  'Peritonealdialysis',
  'Person',
  'PersonalPlan',
  'PersonAndPatient',
  'PersonCancel',
  'PersonInXRayMachine',
  'PersonOverweight',
  'PersonRelaxing',
  'PersonWithBrain',
  'PersonWithBrokenArm',
  'PersonWithCrutches',
  'PersonWithJaw',
  'PersonWithMagnifyingGlass',
  'PersonWithSenses',
  'PersonWorking',
  'PizzaSlice',
  'Plane',
  'Plant',
  'PlateKnifeFork',
  'Play',
  'PlusLarge',
  'PlusSmall',
  'PngFile',
  'Podcast',
  'PoisonInformation',
  'Pregnant',
  'Printer',
  'Psychosis',
  'Publication',
  'Puzzle',
  'QrCode',
  'Quarrel',
  'RadioactiveTreatment',
  'Radioiodine',
  'RadioTherapy',
  'Receipt',
  'Receptionist',
  'Recovery',
  'Referral',
  'Refresh',
  'Refund',
  'Reminder',
  'Reply',
  'Rocket',
  'RtfFile',
  'Save',
  'Scale',
  'ScreenReader',
  'Search',
  'SectionSign',
  'Settings',
  'SettingsFill',
  'Sexualorientation',
  'ShakingHand',
  'Share',
  'SharedHealthData',
  'SharedHealthMeasurements',
  'Shield',
  'ShuntOperation',
  'Skeleton',
  'Skin',
  'Snake',
  'Snapchat',
  'Sort',
  'SortDown',
  'SortUp',
  'SpeechBubble',
  'Spray',
  'StarFill',
  'StarStroke',
  'STDs',
  'StickyNote',
  'StickyNotes',
  'Stopwatch',
  'Sun',
  'SupportingPerson',
  'Surgery',
  'Sweets',
  'Syringe',
  'Taxi',
  'TeddyBear',
  'Teenagers',
  'ThinkingAboutBaby',
  'Ticket',
  'TimePassing',
  'Toddler',
  'Tombstone',
  'Toolbox',
  'Tooth',
  'TotalKneeProsthesis',
  'Train',
  'Transplantation',
  'TrashCan',
  'TravelRoute',
  'TreatmentAids',
  'TriangleX',
  'Twitter',
  'Undo',
  'UniProsthesis',
  'Upload',
  'UserOrganization',
  'Vaccine',
  'VerticalDots',
  'VideoCamera',
  'VideoChat',
  'Wallet',
  'Watch',
  'Website',
  'Wheelchair',
  'WheelchairActive',
  'Window',
  'WordDocument',
  'WorkSuitcase',
  'X',
  'XmlFile',
  'XOutline',
  'YouTube',
  'Zoom',
  'ZoomInLeft',
  'ZoomOutLeft',
] as const;

export type IconName = (typeof IconList)[number];
